// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Carousel__wrapper___BNW49","itemsList":"Carousel__itemsList___3fmHC","item":"Carousel__item___OBRuh"};